import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {GameCenterIndexPageConfig} from "../game-center.index-page.config";
import {computed, observable} from "mobx";
import {WebsiteModuleState} from "../../../../../apps/website/models/website-module.state";
import type {FullGameDomainModel} from "../../../../../domain/full-game/models/full-game-domain-model";
import {GAME_STATUSES} from "../../../../../core/app/consts";
import {GameCenterLinkParams} from "../../../models/game-center-link-params";

export class GameCenterIndexPageState extends BaseModuleState {
  @observable game: FullGameDomainModel;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, GameCenterIndexPageConfig, WebsiteModuleState];

  constructor(
    navigationManager: NavigationManager,
    appStore: AppStore,
    logger: LoggerUtils,
    datetimeUtils: DatetimeUtils,
    device: DeviceViewModel,
    termsUtils: TermsUtils,
    config: GameCenterIndexPageConfig,
    websiteModuleState: WebsiteModuleState
  ) {
    super(navigationManager, appStore, logger, datetimeUtils, device, termsUtils, config)

    this.websiteModuleState = websiteModuleState;
  }

  get isPopulated(): Boolean {
    return this.game;
  }

  @computed get gameCenterLinkParam() {
    return new GameCenterLinkParams(this.props.match.params.competitionKey, this.props.match.params.matchDetails, this.props.match.params.sportName);
  }

  @computed get gameId(): Number {
    return this.props.match.hashParams ? Number(this.props.match.hashParams.id) : null
  }

  @computed get matchupId(): Number {
    return this.gameCenterLinkParam.matchupId
  }

  @computed get sportTypeId(): Number {
    return this.appState.context.sportType?.id;
  }

  @computed get isScheduled(): Boolean {
    return this.game?.statusGroup === GAME_STATUSES.scheduled;
  }
}